import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Home from './components/Home.js'
import Articles from './components/Articles.js'
import Article from './components/Article.js'
import Extra from './components/Extra.js'
import E404 from './components/E404.js'
import './App.css'

//firebase
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

function App() {

  const firebaseConfig = {
    apiKey: "AIzaSyAHgS8Q5mUbdXnLSBlKDeRgsDjlXVl3Snk",
    authDomain: "blog-adam-kaminski.firebaseapp.com",
    projectId: "blog-adam-kaminski",
    storageBucket: "blog-adam-kaminski.appspot.com",
    messagingSenderId: "479060367833",
    appId: "1:479060367833:web:c92d07653a77b78181a1c8",
    measurementId: "G-GNRTCPM9C6",
    databaseURL: "https://blog-adam-kaminski-default-rtdb.europe-west1.firebasedatabase.app"
  };
  //eslint-disable-next-line
  const app = initializeApp(firebaseConfig);
  //eslint-disable-next-line
  const analytics = getAnalytics(app);
  return (
    <Router>
      <div id='container'>
        <Routes>
          <Route path="/" element={<Home></Home>}></Route>
          <Route path="/articles" element={<Articles></Articles>}></Route>
          <Route path="/extra" element={<Extra></Extra>}></Route>
          <Route path="/articles/:id" element={<Article></Article>}></Route>
          <Route path="*" element={<E404></E404>}></Route>
        </Routes>

      </div>
    </Router>
  )
}

export default App